// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1AsBA","inputWrap":"styles_inputWrap__1rxg5","input":"styles_input__3Vyig"};